import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import React from "react";

export type CheckboxInputProps = {
  name: string;
  value?: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  disabled?: boolean;
  id?: string;
  baseHOCClassName?: string;
};

const CheckboxInput = React.forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({ value, onChange, className, disabled, id, name }) => {
    return (
      <Checkbox
        id={id}
        checked={value}
        onCheckedChange={onChange}
        name={name}
        disabled={disabled}
        className={cn("h-4 w-4", className)}
      />
    );
  }
);

CheckboxInput.displayName = "CheckboxInput";

export default CheckboxInput;
